import React from 'react';

import classes from './Spinner.module.css';

const spinner = ({ className }) => (
    <div className={`${classes.Loader} ${className}`}>Loading...</div>
);

export default spinner;